{
  "recruitment.title": "التوظيف",
  "recruitment.subtitle": "الوظائف الشاغرة والمتقدمين والمقابلات، من أول طلب لحد أول يوم شغل.",
  "recruitment.tabs.label": "أقسام التوظيف",
  "recruitment.tabs.openings": "الوظائف الشاغرة",
  "recruitment.tabs.candidates": "المتقدمين",
  "recruitment.tabs.interviews": "مقابلاتي",
  "recruitment.stage.applied": "تقدّم",
  "recruitment.stage.screening": "فرز أولي",
  "recruitment.stage.interview": "مقابلة",
  "recruitment.stage.assessment": "تقييم فني",
  "recruitment.stage.offer": "عرض وظيفي",
  "recruitment.stage.hired": "تم التعيين",
  "recruitment.stageShort.applied": "تقدّم",
  "recruitment.stageShort.screening": "فرز",
  "recruitment.stageShort.interview": "مقابلة",
  "recruitment.stageShort.assessment": "تقييم",
  "recruitment.stageShort.offer": "عرض",
  "recruitment.applicationStatus.active": "قيد المتابعة",
  "recruitment.applicationStatus.rejected": "مرفوض",
  "recruitment.applicationStatus.withdrawn": "انسحب",
  "recruitment.applicationStatus.hired": "تم التعيين",
  "recruitment.openingStatus.draft": "مسودة",
  "recruitment.openingStatus.open": "مفتوحة",
  "recruitment.openingStatus.on_hold": "متوقفة مؤقتًا",
  "recruitment.openingStatus.closed": "مقفولة",
  "recruitment.openingFilter.all": "الكل",
  "recruitment.openingFilter.open": "مفتوحة",
  "recruitment.openingFilter.on_hold": "متوقفة",
  "recruitment.openingFilter.draft": "مسودات",
  "recruitment.openingFilter.closed": "مقفولة",
  "recruitment.employmentKind.full_time": "دوام كامل",
  "recruitment.employmentKind.part_time": "دوام جزئي",
  "recruitment.employmentKind.freelance": "فريلانس",
  "recruitment.employmentKind.internship": "تدريب",
  "recruitment.source.careers_site": "صفحة الوظائف",
  "recruitment.source.referral": "ترشيح",
  "recruitment.source.linkedin": "لينكدإن",
  "recruitment.source.agency": "شركة توظيف",
  "recruitment.source.other": "مصدر تاني",
  "recruitment.interviewKind.video": "مقابلة فيديو",
  "recruitment.interviewKind.phone": "مكالمة تليفون",
  "recruitment.interviewKind.onsite": "مقابلة في المكتب",
  "recruitment.interviewKind.task_review": "مراجعة المهمة",
  "recruitment.interviewStatus.scheduled": "متحددة",
  "recruitment.interviewStatus.done": "تمت",
  "recruitment.interviewStatus.cancelled": "اتلغت",
  "recruitment.recommendation.strong_yes": "موافق بقوة",
  "recruitment.recommendation.yes": "موافق",
  "recruitment.recommendation.no": "مش موافق",
  "recruitment.recommendation.strong_no": "رافض تمامًا",
  "recruitment.rating.1": "ضعيف جدًا",
  "recruitment.rating.2": "ضعيف",
  "recruitment.rating.3": "مقبول",
  "recruitment.rating.4": "جيد",
  "recruitment.rating.5": "ممتاز",
  "recruitment.offerStatus.draft": "مسودة",
  "recruitment.offerStatus.sent": "اتبعت",
  "recruitment.offerStatus.accepted": "اتقبل",
  "recruitment.offerStatus.declined": "اترفض",
  "recruitment.offerStatus.withdrawn": "اتسحب",
  "recruitment.closedFilter.all": "الكل",
  "recruitment.closedFilter.rejected": "مرفوض",
  "recruitment.closedFilter.withdrawn": "انسحب",
  "recruitment.closedFilter.hired": "تم التعيين",
  "recruitment.openings.filterLabel": "عرض الوظائف",
  "recruitment.openings.search": "دوّر في الوظائف",
  "recruitment.openings.new": "وظيفة جديدة",
  "recruitment.openings.loadError": "معرفناش نحمّل الوظائف.",
  "recruitment.openings.emptyTitle": "مفيش وظائف لسه",
  "recruitment.openings.emptyBody": "اعمل وظيفة وانشرها على صفحة الوظائف، والمتقدمين هيبدأوا يوصلوا هنا.",
  "recruitment.openings.emptyMine": "مفيش وظائف ليك",
  "recruitment.openings.emptyMineBody": "الوظائف اللي إنت مسؤول التعيين فيها بتظهر هنا. المقابلات اللي إنت في لجنتها موجودة في «مقابلاتي».",
  "recruitment.openings.noMatch": "مفيش وظائف مطابقة",
  "recruitment.openings.noMatchBody": "جرّب فلتر أو بحث تاني.",
  "recruitment.openings.clearFilters": "امسح الفلاتر",
  "recruitment.opening.headcount": "{count, plural, zero {بدون تعيين} one {تعيين واحد} two {تعيينين} few {# تعيينات} many {# تعيين} other {# تعيين}}",
  "recruitment.opening.hiringManager": "مسؤول التعيين",
  "recruitment.opening.noManager": "مفيش مسؤول تعيين",
  "recruitment.opening.actions": "إجراءات {title}",
  "recruitment.opening.manage": "إدارة",
  "recruitment.opening.edit": "عدّل الوظيفة",
  "recruitment.opening.publish": "انشرها على صفحة الوظائف",
  "recruitment.opening.reopen": "افتحها للتقديم تاني",
  "recruitment.opening.hold": "وقّفها مؤقتًا",
  "recruitment.opening.close": "اقفل الوظيفة",
  "recruitment.opening.published": "الوظيفة اتنشرت على صفحة الوظائف.",
  "recruitment.opening.held": "الوظيفة متوقفة واتشالت من صفحة الوظائف.",
  "recruitment.opening.closed": "الوظيفة اتقفلت.",
  "recruitment.opening.copyLink": "انسخ لينك صفحة الوظيفة",
  "recruitment.opening.closeTitle": "تقفل «{title}»؟",
  "recruitment.opening.closeBody": "هتتشال من صفحة الوظائف ومش هتستقبل طلبات تاني. المتقدمين هيفضلوا ظاهرين، ومش هيترفضوا أوتوماتيك.",
  "recruitment.funnel.label": "{count, plural, zero {مفيش متقدمين نشطين} one {متقدم نشط واحد حسب المرحلة} two {متقدمين نشطين اتنين حسب المرحلة} few {# متقدمين نشطين حسب المرحلة} many {# متقدم نشط حسب المرحلة} other {# متقدم نشط حسب المرحلة}}",
  "recruitment.form.newTitle": "وظيفة جديدة",
  "recruitment.form.editTitle": "تعديل الوظيفة",
  "recruitment.form.description": "اكتب الوظيفة باللغتين: الموقع بيعرض اللغة اللي الزائر بيقرا بيها.",
  "recruitment.form.step.job": "الوظيفة",
  "recruitment.form.step.details": "تفاصيل الشغل",
  "recruitment.form.step.description": "الوصف",
  "recruitment.form.step.descriptionHint": "طبيعة الدور، مين اللي بتدوروا عليه، وإيه اللي بتقدموه.",
  "recruitment.form.titleAr": "المسمى بالعربي",
  "recruitment.form.titleEn": "المسمى بالإنجليزي",
  "recruitment.form.slug": "لينك صفحة الوظيفة",
  "recruitment.form.slugHint": "حروف إنجليزي صغيرة وأرقام وشَرطات. سيبه فاضي ويتعمل من المسمى الإنجليزي.",
  "recruitment.form.slugPreview": "اللينك:",
  "recruitment.form.slugChanged": "تغيير اللينك هيبوّظ اللينكات اللي اتبعتت قبل كده.",
  "recruitment.form.employmentKind": "نوع الشغل",
  "recruitment.form.workMode": "مكان الشغل",
  "recruitment.form.department": "القسم",
  "recruitment.form.location": "المكان",
  "recruitment.form.locationPlaceholder": "القاهرة، مكتب التجمع",
  "recruitment.form.headcount": "عدد المطلوب تعيينهم",
  "recruitment.form.headcountHint": "الوظيفة بتتقفل لما العدد ده يتعيّن.",
  "recruitment.form.hiringManager": "مسؤول التعيين",
  "recruitment.form.hiringManagerHint": "بيحرّك المتقدمين ويكتب ملاحظات ويحدد مقابلات للوظيفة دي.",
  "recruitment.form.hiringManagerNone": "من غير مسؤول تعيين",
  "recruitment.form.descriptionAr": "الوصف بالعربي",
  "recruitment.form.descriptionEn": "الوصف بالإنجليزي",
  "recruitment.form.create": "اعمل الوظيفة",
  "recruitment.form.save": "احفظ التعديلات",
  "recruitment.form.created": "الوظيفة اتعملت كمسودة. انشرها لما تجهز.",
  "recruitment.form.saved": "الوظيفة اتحفظت.",
  "recruitment.form.errors.titleAr": "اكتب المسمى بالعربي.",
  "recruitment.form.errors.titleEn": "اكتب المسمى بالإنجليزي.",
  "recruitment.form.errors.tooLong": "النص ده طويل زيادة.",
  "recruitment.form.errors.slug": "استخدم حروف إنجليزي صغيرة وأرقام وشَرطات بس.",
  "recruitment.form.errors.slugNeeded": "اختار لينك: المسمى الإنجليزي مفيهوش حروف إنجليزي نعمل منها لينك.",
  "recruitment.form.errors.headcount": "اكتب رقم من 1 لـ 50.",
  "recruitment.department.none": "من غير قسم",
  "recruitment.picker.search": "دوّر على شخص",
  "recruitment.picker.empty": "مفيش حد مطابق.",
  "recruitment.board.hiringManager": "مسؤول التعيين: {name}",
  "recruitment.board.closedButton": "المقفولة",
  "recruitment.board.addCandidate": "ضيف متقدم",
  "recruitment.board.loadError": "معرفناش نحمّل مراحل التوظيف.",
  "recruitment.board.column": "{column}: {count, plural, zero {مفيش متقدمين} one {متقدم واحد} two {متقدمين اتنين} few {# متقدمين} many {# متقدم} other {# متقدم}}",
  "recruitment.board.empty": "مفيش حد في المرحلة دي.",
  "recruitment.board.emptyDrop": "اسحب متقدم هنا.",
  "recruitment.board.hiredHint": "الناس بتوصل هنا لما تعيّنهم من عرض وظيفي اتقبل.",
  "recruitment.board.applied": "قدّم {when}",
  "recruitment.board.moveTo": "انقل {name} لـ…",
  "recruitment.board.moveToShort": "انقل لـ…",
  "recruitment.board.moved": "{name} اتنقل لـ{column}.",
  "recruitment.board.moveConflict": "حد عدّل المتقدم ده في نفس الوقت. اللوحة اتحدّثت؛ جرّب تاني.",
  "recruitment.board.stagesLabel": "مراحل التوظيف",
  "recruitment.board.picked": "مسكت {name}.",
  "recruitment.board.over": "{name} فوق {column}.",
  "recruitment.board.dropped": "{name} اتحط في {column}.",
  "recruitment.board.cancelled": "نقل {name} اتلغى.",
  "recruitment.board.instructions": "دوس Space عشان تمسك المتقدم، والأسهم عشان تتحرك بين المراحل والأماكن، وSpace تاني عشان تحطه، وEscape للإلغاء. أو استخدم قائمة «انقل لـ…».",
  "recruitment.closed.title": "الطلبات المقفولة",
  "recruitment.closed.filterLabel": "عرض الطلبات المقفولة",
  "recruitment.closed.applied": "قدّم {date}",
  "recruitment.closed.empty": "مفيش حاجة هنا",
  "recruitment.closed.emptyBody": "المرفوضين واللي انسحبوا واللي اتعيّنوا بيظهروا هنا.",
  "recruitment.candidateForm.title": "ضيف متقدم",
  "recruitment.candidateForm.description": "لحد جه بطريقة تانية: ترشيح أو لينكدإن أو شركة توظيف. بيبدأ من مرحلة «تقدّم».",
  "recruitment.candidateForm.name": "الاسم بالكامل",
  "recruitment.candidateForm.email": "الإيميل",
  "recruitment.candidateForm.phone": "التليفون",
  "recruitment.candidateForm.linkedin": "بروفايل لينكدإن",
  "recruitment.candidateForm.portfolio": "البورتفوليو",
  "recruitment.candidateForm.source": "جه منين",
  "recruitment.candidateForm.referrer": "مرشّح من",
  "recruitment.candidateForm.referrerNone": "اختار مين رشّحه",
  "recruitment.candidateForm.note": "ملاحظة",
  "recruitment.candidateForm.noteHint": "بتظهر في سجل الطلب.",
  "recruitment.candidateForm.submit": "ضيف المتقدم",
  "recruitment.candidateForm.added": "{name} اتضاف في مرحلة «تقدّم».",
  "recruitment.candidateForm.errors.name": "اكتب الاسم.",
  "recruitment.candidateForm.errors.email": "اكتب إيميل صحيح، زي name@example.com.",
  "recruitment.candidateForm.errors.url": "اكتب لينك كامل بيبدأ بـ https://.",
  "recruitment.application.loadError": "معرفناش نحمّل الطلب ده.",
  "recruitment.application.summary": "قدّم على {title} يوم {date} · {label}",
  "recruitment.application.reject": "ارفض",
  "recruitment.application.withdraw": "المتقدم انسحب",
  "recruitment.application.more": "إجراءات تانية",
  "recruitment.application.reopen": "افتح الطلب تاني",
  "recruitment.application.reopened": "{name} رجع لمراحل التوظيف.",
  "recruitment.application.rejectTitle": "ترفض {name}؟",
  "recruitment.application.rejectBody": "اكتب السبب عشان يتسجل للفريق. المتقدم مش هيوصله إيميل.",
  "recruitment.application.withdrawTitle": "{name} انسحب؟",
  "recruitment.application.withdrawBody": "سجّل سبب الانسحاب عشان الفريق.",
  "recruitment.application.rejected": "{name} اترفض.",
  "recruitment.application.withdrawn": "{name} اتسجل إنه انسحب.",
  "recruitment.banner.rejected": "الطلب مرفوض",
  "recruitment.banner.withdrawn": "المتقدم انسحب",
  "recruitment.banner.hiredTitle": "{name} اتعيّن",
  "recruitment.banner.hired": "اتعيّن يوم {date}.",
  "recruitment.banner.openRecord": "افتح ملفه",
  "recruitment.banner.erasedTitle": "البيانات الشخصية اتمسحت",
  "recruitment.banner.erased": "اتمسحت يوم {date}. المراحل والتقييمات والتواريخ فاضلة للتقارير.",
  "recruitment.candidate.contacts": "بيانات التواصل",
  "recruitment.candidate.email": "الإيميل",
  "recruitment.candidate.phone": "التليفون",
  "recruitment.candidate.linkedin": "لينكدإن",
  "recruitment.candidate.portfolio": "البورتفوليو",
  "recruitment.candidate.openCv": "السيرة الذاتية",
  "recruitment.cv.title": "السيرة الذاتية",
  "recruitment.cv.open": "افتحها في تاب جديد",
  "recruitment.cv.none": "مفيش سيرة ذاتية",
  "recruitment.cv.noneBody": "المتقدمين اللي اتضافوا يدوي ملهمش سيرة ذاتية لحد ما يقدّموا من صفحة الوظائف.",
  "recruitment.cv.previewFailed": "معرفناش نعرض السيرة الذاتية هنا.",
  "recruitment.cv.frameTitle": "السيرة الذاتية لـ{name}",
  "recruitment.facts.title": "المتقدم",
  "recruitment.facts.source": "المصدر",
  "recruitment.facts.applied": "تاريخ التقديم",
  "recruitment.facts.consent": "الموافقة",
  "recruitment.facts.noConsent": "اتضاف من الفريق، من غير نموذج موافقة",
  "recruitment.facts.onFile": "متسجل من",
  "recruitment.facts.coverLetter": "خطاب التقديم",
  "recruitment.facts.noCoverLetter": "مفيش خطاب تقديم.",
  "recruitment.timeline.title": "السجل",
  "recruitment.timeline.someone": "حد",
  "recruitment.timeline.appliedOnline": "قدّم من صفحة الوظائف",
  "recruitment.timeline.added": "{actor} ضاف المتقدم",
  "recruitment.timeline.moved": "{actor} نقله من {from} لـ{to}",
  "recruitment.timeline.note": "{actor} كتب ملاحظة",
  "recruitment.timeline.interview_scheduled": "{actor} حدد مقابلة يوم {date}",
  "recruitment.timeline.scorecard": "{actor} بعت بطاقة تقييم",
  "recruitment.timeline.offer_sent": "{actor} بعت العرض الوظيفي",
  "recruitment.timeline.offer_accepted": "المتقدم قبل العرض الوظيفي",
  "recruitment.timeline.offer_declined": "المتقدم رفض العرض الوظيفي",
  "recruitment.timeline.rejected": "{actor} رفض الطلب",
  "recruitment.timeline.withdrawn": "{actor} سجّل إن المتقدم انسحب",
  "recruitment.timeline.reopened": "{actor} فتح الطلب تاني",
  "recruitment.timeline.hired": "{actor} عيّنه بكود {code}",
  "recruitment.timeline.noteLabel": "ملاحظة",
  "recruitment.timeline.notePlaceholder": "اكتب ملاحظة لفريق التوظيف…",
  "recruitment.timeline.noteHint": "كل اللي يقدر يشوف الطلب ده هيقراها، حتى لجنة المقابلة.",
  "recruitment.timeline.addNote": "ضيف ملاحظة",
  "recruitment.timeline.noteAdded": "الملاحظة اتضافت.",
  "recruitment.interviews.title": "المقابلات",
  "recruitment.interviews.schedule": "حدد مقابلة",
  "recruitment.interviews.none": "مفيش مقابلات لسه.",
  "recruitment.interviews.actions": "إجراءات مقابلة {name}",
  "recruitment.interviews.reschedule": "غيّر الميعاد",
  "recruitment.interviews.markDone": "علّم إنها تمت",
  "recruitment.interviews.markedDone": "المقابلة اتعلّمت إنها تمت.",
  "recruitment.interviews.cancel": "الغي المقابلة",
  "recruitment.interviews.keep": "سيبها",
  "recruitment.interviews.cancelTitle": "تلغي المقابلة دي؟",
  "recruitment.interviews.cancelBody": "لجنة المقابلة مش هتكتب بطاقات تقييم ليها. حدد مقابلة جديدة لو لسه عايز تقابله.",
  "recruitment.interviews.cancelled": "المقابلة اتلغت.",
  "recruitment.interviews.join": "ادخل الاجتماع",
  "recruitment.interviews.panel": "لجنة المقابلة",
  "recruitment.interviews.yourScorecard": "بطاقة تقييمك:",
  "recruitment.interviews.editScorecard": "عدّل بطاقة تقييمي",
  "recruitment.interviews.scorecardDue": "مطلوب منك بطاقة تقييم.",
  "recruitment.interviews.writeScorecard": "اكتب بطاقة تقييمي",
  "recruitment.interviews.sentScorecard": "اتبعتت البطاقة · {label}",
  "recruitment.interviews.loadError": "معرفناش نحمّل مقابلاتك.",
  "recruitment.interviews.mineEmpty": "مفيش مقابلات لسه",
  "recruitment.interviews.mineEmptyBody": "لما حد يضيفك للجنة مقابلة، هتظهر هنا مع بطاقة تقييمها.",
  "recruitment.interviews.upcoming": "الجاية",
  "recruitment.interviews.past": "اللي فاتت",
  "recruitment.interviews.noUpcoming": "مفيش مقابلات جاية.",
  "recruitment.interviews.noPast": "مفيش مقابلات فاتت.",
  "recruitment.interviewForm.title": "حدد مقابلة مع {name}",
  "recruitment.interviewForm.rescheduleTitle": "غيّر ميعاد المقابلة مع {name}",
  "recruitment.interviewForm.description": "لجنة المقابلة هيوصلها إشعار بالميعاد والمكان.",
  "recruitment.interviewForm.kind": "النوع",
  "recruitment.interviewForm.date": "اليوم",
  "recruitment.interviewForm.time": "الساعة",
  "recruitment.interviewForm.duration": "المدة",
  "recruitment.interviewForm.minutes": "{minutes, plural, zero {# دقيقة} one {دقيقة واحدة} two {دقيقتين} few {# دقايق} many {# دقيقة} other {# دقيقة}}",
  "recruitment.interviewForm.location": "المكان أو لينك الاجتماع",
  "recruitment.interviewForm.locationHint": "أوضة أو عنوان أو لينك Meet أو Zoom.",
  "recruitment.interviewForm.panel": "لجنة المقابلة",
  "recruitment.interviewForm.panelHint": "كل واحد فيهم بيكتب بطاقة تقييم بعد المقابلة.",
  "recruitment.interviewForm.panelAdd": "ضيف حد للجنة",
  "recruitment.interviewForm.panelChosen": "أعضاء اللجنة",
  "recruitment.interviewForm.panelRemove": "شيل {name}",
  "recruitment.interviewForm.submit": "حدد المقابلة",
  "recruitment.interviewForm.saveReschedule": "احفظ الميعاد الجديد",
  "recruitment.interviewForm.scheduled": "المقابلة اتحددت ولجنة المقابلة وصلها إشعار.",
  "recruitment.interviewForm.rescheduled": "ميعاد المقابلة اتغيّر.",
  "recruitment.interviewForm.errors.date": "اختار اليوم.",
  "recruitment.interviewForm.errors.time": "اختار الساعة.",
  "recruitment.interviewForm.errors.panel": "ضيف شخص واحد على الأقل للجنة.",
  "recruitment.interviewForm.errors.panelMax": "اللجنة أقصاها 10 أشخاص.",
  "recruitment.scorecards.title": "بطاقات التقييم",
  "recruitment.scorecards.average": "المتوسط {rate} من 5 من {count, plural, zero {مفيش بطاقات} one {بطاقة واحدة} two {بطاقتين} few {# بطاقات} many {# بطاقة} other {# بطاقة}}",
  "recruitment.scorecards.tally": "التوصيات",
  "recruitment.scorecards.tallyItem": "{label}: {count}",
  "recruitment.scorecards.none": "مفيش بطاقات تقييم لسه. كل عضو في اللجنة بيكتب بطاقته بعد المقابلة.",
  "recruitment.scorecards.heldBack": "بطاقات تقييم باقي اللجنة هتظهرلك بعد ما تبعت بطاقتك، عشان محدش يتأثر برأي غيره قبل ما يقرر.",
  "recruitment.scorecard.title": "بطاقة تقييمك لـ{name}",
  "recruitment.scorecard.editTitle": "عدّل بطاقة تقييمك لـ{name}",
  "recruitment.scorecard.description": "فريق التوظيف هيقراها. تقدر تعدّلها طول ما المقابلة ما اتلغتش.",
  "recruitment.scorecard.rating": "التقييم العام",
  "recruitment.scorecard.recommendation": "التوصية",
  "recruitment.scorecard.strengths": "نقاط القوة",
  "recruitment.scorecard.concerns": "نقاط القلق",
  "recruitment.scorecard.submit": "ابعت بطاقة التقييم",
  "recruitment.scorecard.save": "احفظ بطاقة التقييم",
  "recruitment.scorecard.submitted": "بطاقة التقييم اتبعتت.",
  "recruitment.scorecard.updated": "بطاقة التقييم اتعدّلت.",
  "recruitment.scorecard.ratedOf": "التقييم {count} من 5",
  "recruitment.scorecard.forInterview": "{label} · {date}",
  "recruitment.scorecard.errors.rating": "اختار التقييم.",
  "recruitment.scorecard.errors.recommendation": "اختار التوصية.",
  "recruitment.offer.title": "العرض الوظيفي",
  "recruitment.offer.description": "اكتبه وابعت للمتقدم اللينك الخاص بيه، وعيّنه لما يقبل.",
  "recruitment.offer.descriptionReader": "حالة العرض. المرتب ظاهر لفريق التوظيف بس.",
  "recruitment.offer.none": "مفيش عرض لسه.",
  "recruitment.offer.noneLive": "مفيش عرض حالي.",
  "recruitment.offer.draft": "اكتب عرض",
  "recruitment.offer.edit": "عدّل المسودة",
  "recruitment.offer.send": "ابعت العرض",
  "recruitment.offer.sendAgain": "ابعته تاني",
  "recruitment.offer.withdraw": "اسحب العرض",
  "recruitment.offer.expiredHint": "انتهى تاريخ هذا العرض، فلا يمكن إرساله مرة أخرى. اسحبه ثم جهّز عرضًا جديدًا.",
  "recruitment.offer.sendTitle": "تبعت العرض لـ{name}؟",
  "recruitment.offer.sendBody": "هنعمل لينك خاص يقرا منه {name} العرض ويرد عليه. انسخه وابعتهوله بالإيميل أو واتساب: 404 OS مش بيبعت إيميلات للمتقدمين.",
  "recruitment.offer.sendAgainTitle": "تبعت العرض لـ{name} تاني؟",
  "recruitment.offer.sendAgainBody": "لينك جديد هيحل محل اللي بعته لـ{name}؛ والقديم هيبطل يشتغل.",
  "recruitment.offer.sent": "العرض اتبعت. انسخ اللينك وابعته.",
  "recruitment.offer.withdrawTitle": "تسحب العرض من {name}؟",
  "recruitment.offer.withdrawBody": "اللينك بتاعه هيبطل يشتغل. تقدر تكتب عرض جديد بعدين.",
  "recruitment.offer.withdrawn": "العرض اتسحب.",
  "recruitment.offer.linkLabel": "اللينك الخاص بـ{name}",
  "recruitment.offer.linkHint": "أي حد معاه اللينك ده يقدر يرد على العرض؛ ابعته للمتقدم بس.",
  "recruitment.offer.linkHidden": "اللينك بيظهر مرة واحدة وقت إرسال العرض. عشان تبعته تاني، ابعت العرض تاني: لينك جديد هيحل محل القديم.",
  "recruitment.offer.emailIt": "ابعته بالإيميل",
  "recruitment.offer.mailSubject": "عرضك الوظيفي من 404 Creative",
  "recruitment.offer.mailBody": "أهلاً {name}،\n\nعرضك الوظيفي جاهز. تقدر تقراه وترد عليه من هنا:\n{link}\n\n404 Creative",
  "recruitment.offer.readyToHire": "{name} قبل العرض. عيّنه عشان يتعمله حساب وملف.",
  "recruitment.offer.past": "{count, plural, zero {مفيش عروض سابقة} one {عرض سابق} two {عرضين سابقين} few {# عروض سابقة} many {# عرض سابق} other {# عرض سابق}}",
  "recruitment.offer.answerBy": "الرد قبل {date}",
  "recruitment.offer.when.sent": "اتبعت {date}",
  "recruitment.offer.when.accepted": "اتقبل {date}",
  "recruitment.offer.when.declined": "اترفض {date}",
  "recruitment.offer.role": "المسمى الوظيفي",
  "recruitment.offer.contract": "نوع العقد",
  "recruitment.offer.start": "تاريخ البدء",
  "recruitment.offer.salary": "صافي المرتب الشهري",
  "recruitment.offer.noSalary": "مش محدد",
  "recruitment.offer.probation": "فترة الاختبار",
  "recruitment.offer.expires": "آخر ميعاد للرد",
  "recruitment.offerForm.newTitle": "اكتب عرض وظيفي لـ{name}",
  "recruitment.offerForm.editTitle": "عدّل العرض الوظيفي لـ{name}",
  "recruitment.offerForm.description": "مفيش حاجة هتوصل للمتقدم غير لما تبعت العرض.",
  "recruitment.offerForm.title": "المسمى الوظيفي",
  "recruitment.offerForm.contract": "نوع العقد",
  "recruitment.offerForm.startDate": "تاريخ البدء",
  "recruitment.offerForm.salary": "صافي المرتب الشهري",
  "recruitment.offerForm.salaryHint": "بالجنيه المصري بعد الضرايب والتأمينات. سيبه فاضي لو مش عايز المرتب يظهر في العرض.",
  "recruitment.offerForm.probation": "فترة الاختبار",
  "recruitment.offerForm.noProbation": "من غير فترة اختبار",
  "recruitment.offerForm.months": "{months, plural, zero {# شهر} one {شهر واحد} two {شهرين} few {# شهور} many {# شهر} other {# شهر}}",
  "recruitment.offerForm.expiresOn": "آخر ميعاد للرد",
  "recruitment.offerForm.expiresHint": "بعد اليوم ده اللينك مش هيقبل رد.",
  "recruitment.offerForm.message": "رسالة للمتقدم",
  "recruitment.offerForm.messageHint": "هتظهر في صفحة العرض بتاعته.",
  "recruitment.offerForm.save": "احفظ المسودة",
  "recruitment.offerForm.saved": "مسودة العرض اتحفظت.",
  "recruitment.offerForm.errors.title": "اكتب المسمى الوظيفي.",
  "recruitment.offerForm.errors.startDate": "اختار تاريخ البدء.",
  "recruitment.offerForm.errors.salary": "اكتب مبلغ بالجنيه، زي 15,000.",
  "recruitment.offerForm.errors.expiresOn": "اختار آخر يوم للرد.",
  "recruitment.offerForm.errors.expiresPast": "اختار النهارده أو يوم بعده.",
  "recruitment.hire.open": "عيّن",
  "recruitment.hire.title": "تعيين {name}",
  "recruitment.hire.description": "ده هيعمله حساب في النظام وملف موظف وقائمة استلام شغل.",
  "recruitment.hire.stepsLabel": "خطوات التعيين",
  "recruitment.hire.step.details": "البيانات",
  "recruitment.hire.step.confirm": "الاستلام والتأكيد",
  "recruitment.hire.email": "إيميل الشغل",
  "recruitment.hire.emailHint": "الدعوة هتتبعت هنا، وده هيبقى إيميل الدخول بتاعه.",
  "recruitment.hire.hireDate": "أول يوم شغل",
  "recruitment.hire.probationEnd": "نهاية فترة الاختبار",
  "recruitment.hire.noProbation": "من غير فترة اختبار",
  "recruitment.hire.department": "القسم",
  "recruitment.hire.manager": "المدير المباشر",
  "recruitment.hire.managerHint": "مسؤول التعيين، إلا لو اخترت حد تاني.",
  "recruitment.hire.managerNone": "من غير مدير",
  "recruitment.hire.workMode": "مكان الشغل",
  "recruitment.hire.template": "قائمة استلام الشغل",
  "recruitment.hire.templateHint": "مهام للـHR والمدير والموظف من أول يوم.",
  "recruitment.hire.templateNone": "من غير قائمة",
  "recruitment.hire.whatHappens": "التعيين بيعمل إيه",
  "recruitment.hire.explainAccount": "{name} هيدخل الفريق بصلاحية عضو، وبملف موظف من شروط العرض.",
  "recruitment.hire.explainRole": "الأدمن يقدر يغيّر صلاحياته بعدين.",
  "recruitment.hire.explainInvite": "دعوة لتعيين الباسورد هتتبعت على {email}.",
  "recruitment.hire.next": "التالي",
  "recruitment.hire.back": "رجوع",
  "recruitment.hire.submit": "عيّن {name}",
  "recruitment.hire.doneDialogTitle": "{name} بقى في الفريق",
  "recruitment.hire.doneTitle": "أهلاً بيك في الفريق يا {name}!",
  "recruitment.hire.doneCode": "كود الموظف:",
  "recruitment.hire.inviteLink": "لينك الدعوة",
  "recruitment.hire.inviteHint": "اتبعت بالإيميل كمان. بيظهر دلوقتي بس؛ ابعته لو الإيميل موصلش.",
  "recruitment.hire.openRecord": "افتح ملفه",
  "recruitment.hire.errors.email": "اكتب إيميل الشغل بتاعه.",
  "recruitment.hire.errors.hireDate": "اختار أول يوم شغل.",
  "recruitment.hire.errors.probationEnd": "فترة الاختبار لازم تخلص بعد أول يوم.",
  "recruitment.erase.action": "امسح البيانات الشخصية",
  "recruitment.erase.title": "تمسح بيانات {name}؟",
  "recruitment.erase.body": "الاسم وبيانات التواصل واللينكات والسيرة الذاتية وخطابات التقديم والملاحظات وتعليقات بطاقات التقييم هتتمسح من كل طلباته. المراحل والتقييمات والتواريخ هتفضل للتقارير.",
  "recruitment.erase.final": "مفيش رجوع في الخطوة دي. اعملها لما المتقدم يطلب مسح بياناته.",
  "recruitment.erase.typeName": "اكتب {name} للتأكيد",
  "recruitment.erase.confirm": "امسح البيانات",
  "recruitment.erase.done": "بيانات المتقدم اتمسحت.",
  "recruitment.erase.sectionTitle": "إخفاء البيانات بناءً على طلب",
  "recruitment.erase.sectionBody": "حسب قانون حماية البيانات المصري، المتقدم من حقه يطلب مسح بياناته.",
  "recruitment.candidates.title": "المتقدم",
  "recruitment.candidates.intro": "كل اللي قدّموا أو اتضافوا، الأحدث نشاطًا الأول.",
  "recruitment.candidates.search": "دوّر بالاسم أو الإيميل",
  "recruitment.candidates.loadError": "معرفناش نحمّل المتقدمين.",
  "recruitment.candidates.empty": "مفيش متقدمين لسه",
  "recruitment.candidates.emptyBody": "المتقدمين بيظهروا لما يقدّموا من صفحة الوظائف أو تضيفهم لوظيفة.",
  "recruitment.candidates.noMatch": "مفيش حد مطابق",
  "recruitment.candidates.noMatchBody": "جرّب جزء من الاسم أو الإيميل.",
  "recruitment.candidates.since": "من {date}",
  "recruitment.candidates.consent": "وافق يوم {date}",
  "recruitment.candidates.applications": "{count, plural, zero {مفيش طلبات} one {طلب واحد} two {طلبين} few {# طلبات} many {# طلب} other {# طلب}}",
  "recruitment.public.pageTitle": "عرضك الوظيفي",
  "recruitment.public.switch": "English",
  "recruitment.public.greeting": "عزيزي {name}،",
  "recruitment.public.headline": "يسعدنا إنك تنضم لينا في وظيفة {title}",
  "recruitment.public.salary": "صافي المرتب الشهري",
  "recruitment.public.expires": "برجاء الرد قبل",
  "recruitment.public.message": "رسالة من الفريق",
  "recruitment.public.answerTitle": "ردّك",
  "recruitment.public.note": "ملاحظة (اختياري)",
  "recruitment.public.noteHint": "أي حاجة حابب الفريق يعرفها.",
  "recruitment.public.accept": "أقبل العرض",
  "recruitment.public.decline": "أعتذر عن العرض",
  "recruitment.public.final": "ردّك نهائي وهيوصل لفريق التوظيف على طول.",
  "recruitment.public.acceptTitle": "تقبل العرض ده؟",
  "recruitment.public.declineTitle": "تعتذر عن العرض ده؟",
  "recruitment.public.confirmBody": "مش هتقدر تغيّر ردّك بعد كده.",
  "recruitment.public.acceptConfirm": "أيوه، أقبل",
  "recruitment.public.declineConfirm": "أيوه، أعتذر",
  "recruitment.public.acceptedTitle": "قبلت العرض يوم {date}",
  "recruitment.public.acceptedBody": "أهلاً بيك معانا! هنتواصل معاك بخصوص أول يوم.",
  "recruitment.public.declinedTitle": "اعتذرت عن العرض يوم {date}",
  "recruitment.public.declinedBody": "شكرًا إنك بلغتنا. بنتمنالك كل التوفيق.",
  "recruitment.public.expiredTitle": "العرض ده انتهى يوم {date}",
  "recruitment.public.expiredBody": "تواصل معانا لو لسه مهتم.",
  "recruitment.public.withdrawnTitle": "العرض ده اتسحب",
  "recruitment.public.withdrawnBody": "تواصل مع اللي بعتلك العرض لو عندك أي سؤال.",
  "recruitment.public.invalidTitle": "اللينك ده مش صالح",
  "recruitment.public.invalidBody": "ممكن يكون قديم أو متكتب غلط. اطلب لينك جديد من اللي بعتهولك.",
  "recruitment.public.loadError": "معرفناش نحمّل العرض",
  "recruitment.public.loadErrorBody": "اتأكد من الإنترنت وجرّب تاني.",
  "recruitment.public.footer": "عندك أسئلة؟ رد على اللي بعتلك اللينك ده.",
  "recruitment.errors.alreadyApplied": "الشخص ده قدّم على الوظيفة دي قبل كده.",
  "recruitment.errors.slugTaken": "فيه وظيفة تانية بتستخدم اللينك ده.",
  "recruitment.errors.applicationClosed": "الطلب ده اترفض أو انسحب صاحبه أو اتعيّن.",
  "recruitment.errors.offerState": "الخطوة دي مش مناسبة لحالة العرض دلوقتي. حدّث الصفحة عشان تشوف حالته.",
  "recruitment.errors.offerLinkInvalid": "لينك العرض ده مبقاش صالح.",
  "recruitment.errors.offerExpired": "العرض ده انتهى.",
  "recruitment.errors.emailTaken": "فيه حد في الفريق بيستخدم الإيميل ده.",
  "recruitment.errors.conflict": "حد تاني عدّل ده في نفس الوقت. حدّث الصفحة وجرّب تاني.",
  "recruitment.errors.notFound": "ده مبقاش موجود.",
  "recruitment.errors.rateLimited": "محاولات كتير. استنى دقيقة وجرّب تاني.",
  "recruitment.offer.expiryPassed": "آخر ميعاد للرد فات. عدّل المسودة، أو اسحب العرض واكتب عرض جديد، بميعاد بعد كده."
}
